/* Progressive enhancement only. Native Shopify forms work without JS.
   No AJAX interception: submit -> Shopify cart. No custom cart drawer events.
   Custom element reconnects safely after Shopify theme-editor section reload. */
(() => {
  if (customElements.get('sa-home')) return;
  customElements.define('sa-home', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const opts = {signal:this.controller.signal};
      this.querySelector('[data-filters]').hidden = false;
      this.addEventListener('click', event => {
        const choice = event.target.closest('[data-choice]');
        if (!choice || !this.contains(choice)) return;
        this.choose(choice.dataset.choice);
      }, opts);
      this.addEventListener('change', event => {
        if(event.target.matches('[data-variant]')) this.updateVariant(event.target);
      }, opts);
      this.querySelectorAll('[data-variant]').forEach(select=>this.updateVariant(select));
      const applyEntry=()=>{
        const params=new URLSearchParams(location.search);
        const value=params.get('sa_product') || location.hash.slice(1);
        this.choose(['play','unwind','all'].includes(value)?value:(this.dataset.default||'all'));
      };
      window.addEventListener('hashchange',applyEntry,opts);
      applyEntry();
    }
    disconnectedCallback(){this.controller?.abort();}
    choose(key){
      if(!['all','play','unwind'].includes(key)) key='all';
      this.querySelectorAll('[data-choice]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.choice===key)));
      this.querySelectorAll('[data-product]').forEach(p=>{p.hidden=key!=='all'&&p.dataset.product!==key;});
      this.querySelector('[data-products]').dataset.single=String(key!=='all');
      this.querySelector('[data-filter-status]').textContent=key==='all'?'Palygink abu skonius ir rinkis savo.':key==='play'?'Tavo pasirinkimas: PLAY. Švelnesnis kartumas, vaisių ir citrusų natos.':'Tavo pasirinkimas: UNWIND. Ryškesnis IPA ir apynių charakteris.';
    }
    updateVariant(select){
      const form=select.closest('form'),option=select.selectedOptions[0];
      if(!form||!option)return;
      form.querySelector('[data-price-output]').textContent=option.dataset.price||'';
      const button=form.querySelector('[data-add]');
      if(button){button.disabled=option.dataset.available!=='true';button.querySelector('[data-add-label]').textContent=button.disabled?'Išparduota':'Į krepšelį';}
      const qty=form.querySelector('[data-quantity]');
      const min=Number(option.dataset.min)||1,step=Number(option.dataset.step)||1,max=Number(option.dataset.max)||null;
      qty.min=min;qty.step=step;if(max)qty.max=max;else qty.removeAttribute('max');
      let value=Math.max(min,Number(qty.value)||min);
      value=min+Math.floor((value-min)/step)*step;
      if(max&&value>max)value=min+Math.floor((max-min)/step)*step;
      qty.value=Math.max(min,value);
    }
  });
})();
